/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./curve-editor.vue?vue&type=template&id=2244f8d4&"
import script from "./curve-editor.vue?vue&type=script&lang=js&"
export * from "./curve-editor.vue?vue&type=script&lang=js&"
import style0 from "./curve-editor.vue?vue&type=style&index=0&id=2244f8d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports